import { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

import './App.css';
import AppMenu from './navigation/appMenu/AppMenu';
import LandingPage from './components/landing/Landing';
import config from './conf/config';

const App = () => {
  const [isUserVerified, setIsUserVerified] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    if (config.appMode === 'dev') {
      setIsUserVerified(true);
      setLoading(false);
    } else {
      const unsubscribe = onAuthStateChanged(getAuth(), (userObj) => {
        setLoading(false);
        if (userObj) {
          setIsUserVerified(userObj.emailVerified);
        } else {
          setIsUserVerified(false);
        }
      });
      return () => unsubscribe();
    }
  }, []);

  return (
    <>
      <AppMenu isUserVerified={isUserVerified} />
      <div
        style={{
          marginTop: '70px',
        }}
      >
        <LandingPage loading={loading} isUserVerified={isUserVerified} />
      </div>
    </>
  );
};

export default App;
